import { useServices } from "@/hooks/useServices"
import { WIDTH_DEFAULT } from "@/organisms/Drawers/const"
import { AiPolicyProvider } from "@/pages/GovernancePage/components/organisms/AiPolicyProvider"
import { TabsDrawerTemplate } from "../TabsDrawerTemplate"
import { AiComponentsTabAgentAiDiscoveryDrawer } from "./components/AiComponentsTabAgentAiDiscoveryDrawer"
import { AiPolicyTabAgentAiDiscoveryDrawer } from "./components/AiPolicyTabAgentAiDiscoveryDrawer"
import { AiRiskTabAgentAiDiscoveryDrawer } from "./components/AiRiskTabAgentAiDiscoveryDrawer/AiRiskTabAgentAiDiscoveryDrawer"
import { HardeningBelowTabs } from "./components/HardenAgent"
import { OverviewTabAgentAiDiscoveryDrawer } from "./components/OverviewTabAgentAiDiscoveryDrawer"
import { TitleAgentAiDiscoveryDrawer } from "./components/TitleAgentAiDiscoveryDrawer"
import { TABS, TABS_DEMO } from "./const"

import styles from "./AgentAiDiscoveryDrawer.module.scss"

import type { TabsDrawerTemplateProps } from "../TabsDrawerTemplate"

const DEFAULT_TABS = [TABS.overview, TABS.aiComponents, TABS.aiRisks]
const DEFAULT_COMPONENTS = [
  OverviewTabAgentAiDiscoveryDrawer,
  AiComponentsTabAgentAiDiscoveryDrawer,
  AiRiskTabAgentAiDiscoveryDrawer
]

export const AgentAiDiscoveryDrawer = (
  props: Omit<TabsDrawerTemplateProps, "name" | "tabs" | "components"> & {
    widthAdditive: number
  }
) => {
  const { widthAdditive, ...restProps } = props
  const { auth } = useServices()
  const isDemo = auth.isDemo()
  const tabs = isDemo ? [...DEFAULT_TABS, TABS_DEMO.aiPolicy] : DEFAULT_TABS
  const components = isDemo
    ? [...DEFAULT_COMPONENTS, AiPolicyTabAgentAiDiscoveryDrawer]
    : DEFAULT_COMPONENTS

  const drawer = (
    <TabsDrawerTemplate
      classes={{ drawer: styles.drawer }}
      name="AgentAiDiscoveryDrawer"
      tabs={tabs}
      components={components}
      Title={TitleAgentAiDiscoveryDrawer}
      Below={isDemo ? HardeningBelowTabs : undefined}
      // Harden switches to the AI Policy tab, which needs the tabs controlled.
      controlledActiveKey={isDemo}
      width={WIDTH_DEFAULT + widthAdditive}
      {...restProps}
    />
  )

  if (!isDemo) return drawer

  // The hardening banner needs the policies on every tab, not only on the AI
  // Policy tab; nested providers share one store.
  return <AiPolicyProvider>{drawer}</AiPolicyProvider>
}
